import React from 'react';
import { Timeline, TimelineEvent } from 'react-event-timeline';
import { Box, Heading, Image, Text } from '@chakra-ui/react';
import { AiOutlineHeart } from 'react-icons/ai';

import { useGuest } from '@/context/guest';
import useLang from '@/hooks/useLang';
import WithAnimation from '@/components/Common/WithAnimation';

import { ENABLE_LOVE_STORY } from '@/constants/feature-flags';
import { TEXT_PROPS } from '@/constants/default-props';
import loveStoryData from '@/constants/love-story';
import { ID_LOVESTORY_SECTION } from '@/constants/identifier';

import txtWording from './locales';

function LoveStory() {
  const lang = useLang();
  const { guest } = useGuest();
  const { name } = guest;

  const finalLoveStory = loveStoryData;

  const renderIcon = (img) => {
    if (img) {
      return (
        <Image
          src={img}
          boxSize="50px"
          borderRadius="full"
          objectFit="cover"
          objectPosition="center"
        />
      );
    }

    return <AiOutlineHeart color="white" size="18px" />;
  };

  return (
    <Box bgColor="bgPrimary" padding="42px 0 0 0" name={ID_LOVESTORY_SECTION}>
      <Box paddingBottom="42px" color="mainColorText">
        <Text textAlign="center" fontWeight="light" fontFamily="body">
          {txtWording.textDear[lang]}
        </Text>
        <Text fontSize="xl" textAlign="center" fontFamily="body" fontWeight="bold">
          {name || `${txtWording.guest[lang]}`}
        </Text>
      </Box>
      {ENABLE_LOVE_STORY && (
        <>
          <Heading
            {...TEXT_PROPS.subHeading}
            color="mainColorText"
            textAlign="left"
            paddingLeft="24px"
          >
            {txtWording.lovestory[lang]}
          </Heading>
          <Box borderRadius="16px" padding="16px">
            <Timeline
              lineColor="var(--chakra-colors-bgSecondary)"
              lineStyle={{ top: '20px', height: 'calc(100% - 60px)', left: '8px' }}
            >
              {finalLoveStory.map((item, index) => {
                return (
                  <WithAnimation key={`index-${index}`}>
                    <TimelineEvent
                      title={item.title}
                      titleStyle={{
                        fontFamily: 'var(--chakra-fonts-subHeading)',
                        color: 'var(--chakra-colors-mainColorText)',
                        fontWeight: 'normal',
                        paddingLeft: '0',
                        fontSize: '16px',
                      }}
                      subtitleStyle={{
                        color: 'var(--chakra-colors-bgAlternative)',
                        fontFamily: 'var(--chakra-fonts-body)',
                      }}
                      cardHeaderStyle={{ color: 'white' }}
                      icon={false && renderIcon(item.img)}
                      // iconStyle={{ width: '50px', height: '50px' }}
                      bubbleStyle={{
                        width: '16px',
                        height: '16px',
                        border: 'none',
                        backgroundColor: 'var(--chakra-colors-bgSecondary)',
                      }}
                      contentStyle={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        padding: '0',
                        color: 'var(--chakra-colors-bgAlternative)',
                        fontSize: 'var(--chakra-fontSizes-body)',
                        fontWeight: 'var(--chakra-fontWeights-body)',
                        fontFamily: 'var(--chakra-fonts-body)',
                        paddingLeft: '0',
                        marginTop: '8px',
                      }}
                    >
                      <span dangerouslySetInnerHTML={{ __html: item.description }} />
                    </TimelineEvent>
                  </WithAnimation>
                );
              })}
            </Timeline>
          </Box>
        </>
      )}
    </Box>
  );
}

export default LoveStory;
